<main>
  <div class="flex items-center justify-center w-screen h-screen">
    <div class="px-4 lg:py-12">
      <div class="lg:gap-4 lg:flex">
        <div class="flex flex-col items-center justify-center md:py-24 lg:py-32">
          <h1
            class="font-bold text-transparent bg-clip-text bg-gradient-to-br from-amber-400 to-amber-600 text-9xl">
            403</h1>
          <p class="mt-4 mb-2 text-2xl font-bold text-center text-gray-800 md:text-3xl">Acesso Proibido</p>
          <p class="mb-8 text-center text-gray-500 md:text-lg">
            O seu utilizador não tem permissão para aceder a está navegação ou operação.
          </p>
        </div>
      </div>
    </div>
  </div>
</main>
